// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1mX07","productName":"Table_productName__ZweY0"};